import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { AiOutlineUser } from 'react-icons/ai'
import { CgMenuLeft } from 'react-icons/cg'
import MobileSlider from './MobileSlider'
import Logo from '../../assets/images/logo/logo.png'
import { useSelector } from 'react-redux'

function Header() {

    const [fiexed, setFixed] = useState(false)

    const { user } = useSelector((state) => state.auth)

    const fixed = () => {
        if (window.scrollY >= 90) {
            setFixed(true)
        } else {
            setFixed(false)
        }
    }

    window.addEventListener('scroll', fixed)

    return (

        <>

            <nav style={{ borderRadius: '0' }} className={`navbar navbar-expand-lg navbar-light style-4 mt-0 ${fiexed && 'nav-scroll'}`}>
                <div className="container">

                    <Link to='/' className="navbar-brand" >
                        <img src={Logo} alt="Logo" />
                    </Link>

                    <button className="navbar-toggler" >

                        <span style={{ fontSize: '25px' }} type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions" ><CgMenuLeft /></span>

                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">

                        <ul className="navbar-nav m-auto mb-2 mb-lg-0 text-uppercase">

                            <li className="nav-item">
                                <Link className="nav-link" to="/">
                                    HOME
                                </Link>
                            </li>

                            {/* <li className="nav-item">
                                <a className="nav-link" href="https://dashboard.rundeliverys.com/ride-for-run" target='_blank' rel='noreferrer'>
                                    BECOME A RUN CHAMPION
                                </a>
                            </li> */}

                            <li className="nav-item">
                                <Link className="nav-link" to="/ride-for-run">
                                    BECOME A RUN CHAMPION
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/business" >
                                    Business
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/inter-state-delivery" >
                                    InterState Delivery
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to="/rep-for-run" >
                                    Rep-for-run
                                </Link>
                            </li>

                            <li className="nav-item">
                                <Link className="nav-link" to='/terms'>
                                    PRIVACY/TERMS OF SERVICE
                                </Link>
                            </li>

                        </ul>

                        <div className="nav-side">

                            <div className="d-flex align-items-center">

                                {/* { !user ?

                                    <Link to='/login' className="search-icon me-4">
                                        <AiOutlineUser />
                                    </Link>

                                    :

                                    <Link to='/dashboard' className="search-icon me-4">
                                        <AiOutlineUser />
                                    </Link>

                                } */}

                                <Link to='/contact' className="btn rounded-pill brd-gray hover-blue4 sm-butn fw-bold">
                                    <span> Contact Us  <i className="bi bi-arrow-right ms-1"></i> </span>
                                </Link>

                            </div>

                        </div>

                    </div>

                </div>
            </nav>

            <MobileSlider />

        </>

    )
}

export default Header